<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.3081 7.4H14.6831"
      :stroke="getColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.31689 7.4L5.94189 8.025L7.81689 6.15"
      :stroke="getColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3081 13.2333H14.6831"
      :stroke="getColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.31689 13.2333L5.94189 13.8583L7.81689 11.9833"
      :stroke="getColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.49984 18.3333H12.4998C16.6665 18.3333 18.3332 16.6667 18.3332 12.5V7.5C18.3332 3.33333 16.6665 1.66666 12.4998 1.66666H7.49984C3.33317 1.66666 1.6665 3.33333 1.6665 7.5V12.5C1.6665 16.6667 3.33317 18.3333 7.49984 18.3333Z"
      :stroke="getColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconOrders',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '20'
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    getColor() {
      if (this.color) {
        return this.color;
      }
      if (this.disabled) {
        return this.$whitelabel.lightTheme.textPrimary.lighten4;
      }
      return this.$whitelabel.lightTheme.textPrimary.lighten5;
    }
  }
};
</script>
